import { gql } from 'apollo-angular';
import {  LINK_FIELDS } from 'src/app/gql'

export const CF = gql`
  fragment CF on ContentFinder {
    title
    backgroundColor {
      color
    }
    header
    hTag
    content
    contentFinderBtn {
      ...LINK_FIELDS
    }
    contentType
    featuredContent
    enableFinder
    enableSearch
    externalArticlesCollection (limit: 10){
      items {
        url
        articleTeaser
        blogHeader
        isNewsArticle
        publishedDate
        blogImg{
          url
          description
        }
        blogCategory {
          heading
          url
        }
        sys {
          id
        }
      }
    }
  }
  ${LINK_FIELDS}
`; 
